// 财务1  菜单
const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/home',
    title: '系统首页',
  },
  {
    icon: 'el-icon-user',
    index: '/userList',
    title: '用户管理',
  },
  {
    icon: 'el-icon-s-order',
    index: '3',
    title: '订单管理',
    subs: [
      {
        index: '/orderList',
        title: '订单管理',
      },
      {
        index: '/settlementOrderList',
        title: '结算列表',
      },
    ]
  },
  {
    icon: 'el-icon-lx-copy',
    index: '7',
    title: '运营管理',
    subs: [
      {
        index: '/withdrawAuditList',
        title: '提现审核',
      },
      {
        index: '/shopList',
        title: '店铺管理',
      },
      {
        index: '/shopWealthRecordList',
        title: '店铺流水',
      },
    ],
  },
  {
    icon: 'el-icon-lx-cascades',
    index: '12',
    title: '会员管理',
    subs: [
      {
        index: '/memberAddressConfigList',
        title: '区域代理设置',
      }
    ],
  },
  {
    icon: 'el-icon-lx-cascades',
    index: '13',
    title: '绿豆活动管理',
    subs: [
      {
        index: '/userWealthRecordList',
        title: '用户积分记录',
      },
      {
        index: '/userPointsRecordList',
        title: '积分明细',
      },
      {
        index: '/distributionActivityRecordList',
        title: '绿豆发放记录',
      },

    ],
  },{
    icon: 'el-icon-lx-cascades',
    index: '14',
    title: '统计分析 ',
    subs: [
      {
        index: '/statistical/financeStatisticalIndex',
        title: '财务统计',
      },
      {
        index: '/statistical/financeSalesStatList',
        title: '财务销售明细统计',
      },
      {
        index: '/statistical/financeMungBeanStatList',
        title: '财务绿豆明细统计',
      },
    ],
  },

]

export default menus
